
import axios, { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyPostYear, ResponseGetYears, ResponseGetYearsId, ResponsePatchYear, ResponsePostYears } from "./interfaceYears";


export const getYear = async (): Promise<ResponseGetYears[]> => {
    try {
        const data = await getApi(`/years`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetYears[];
    }
}

export const getYearsYear = async (year?: string): Promise<ResponseGetYearsId[]> => {
    try {
        const data = await getApi(`/years/${year ? year : ""}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetYearsId[];
    }
}


export const postYear = async (body: BodyPostYear): Promise<ResponsePostYears> => {
    try {
        const data = await postApi('/years', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetYears;
    }
}


export const getYearId = async (term?: number): Promise<ResponseGetYearsId> => {
    try {
        const data = await getApi(`/years/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetYearsId;
    }
}


export const patchYear = async (body: BodyPostYear, id?: number): Promise<ResponsePatchYear> => {
    try {
        const data = await patchApi(`/years/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePatchYear;
    }
}

export const deleteYear = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/years/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


